import "./EditionBadge.css";

/** Small badge showing a document's edition. Renders nothing for a missing or
 * blank edition (legacy documents); marks auto-detected values so users know
 * to confirm them. */
export default function EditionBadge({ edition, source }) {
  if (!edition || !edition.trim()) return null;
  return (
    <span
      className={`edition-badge${source === "auto" ? " edition-badge-auto" : ""}`}
      data-testid="edition-badge"
      data-source={source || ""}
      title={source === "auto" ? "Auto-detected edition" : "Edition"}
      dir="auto"
    >
      {edition}
    </span>
  );
}
